/**
 * Which CMS instance the admin is looking at, sandbox or live.
 *
 * Replaces Angular's `instanceService` and the `CMS_INSTANCES` constant. It is a module-level
 * value rather than React state because the preview window reads it outside any component,
 * and because the Angular version was the same: one value on a service, read from wherever.
 *
 * The Angular service broadcast `cmsInstanceChanged` on a write. Nothing subscribes any more:
 * the only listeners were the Manage Assets screen and `root_controller`, both deleted. The
 * setter is kept because the value is still read, and a future instance switcher will want it.
 */
export const CMS_INSTANCES = {
  sandbox: { id: 'sandbox', label: 'Sandbox', editable: true, order: 0 },
  live: { id: 'live', label: 'Live', editable: false, order: 1 },
};

export const instances = Object.values(CMS_INSTANCES);

const stored = () => {
  try {
    return window.localStorage.cms_instance;
  } catch {
    // Private browsing and blocked site data both throw on access rather than returning
    // undefined, and a CMS that will not boot because of a storage setting is a bad trade.
    return undefined;
  }
};

let active = instances.find((i) => i.id === stored()) || CMS_INSTANCES.sandbox;

export const activeInstance = () => active;

export const setActiveInstance = (instance) => {
  active = instance;
  try {
    window.localStorage.cms_instance = instance.id;
  } catch {
    /* see above */
  }
};
